<template>
  <div
    class="desktop-view page admin-inner-page"
  >
    <div class="sensata-splash-wrapper" @click="goToAdmin()">
      <SensataSplash></SensataSplash>
    </div>

    <div class="admin-content-wrapper delay-entry">
      <div v-if="loggedIn && authorized">
        <h2 class="survey-name">{{surveyName}}</h2>
      </div>
      <section class="view-section delay-entry delay-like-crazy">
        <p v-if="loggedIn && !authorized">No tienes autorización para ver esta página. Solicita tu acceso al administrador.</p>

        <div v-if="loggedIn && authorized" class="mongodb-charts-wrapper">
          <div
            :id="`chart-${chart.id}`"
            v-for="chart in chartsList.charts"
            class="chart-block"
            :class="{'large': chart.large, 'xlarge': chart.xlarge}"
          ></div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import ChartsEmbedSDK from '@mongodb-js/charts-embed-dom'

export default {
  name: 'MongoDBCharts',

  data () {
    return {
    }
  },

  components: {
    Icons: () => import('Components/base/Icons'),
    SensataSplash: () => import('Components/base/SensataSplash'),
  },

  computed: {
    username () {
      return this.$store.state.user.auth0.name || 'Stranger'
    },
    user () {
      return this.$store.state.user.auth0
    },
    loggedIn () {
      return this.$store.state.user.loggedIn
    },
    survey () {
      return this.$store.state.admin.sidList[this.$route.params.sid]
    },
    surveyName () {
      return this.survey ? this.survey.surveyName : ''
    },
    namespace () {
      return process.env.VUE_APP_NAMESPACE
    },
    authorized () {
      if (this.user && this.user[this.namespace] && this.user[this.namespace].mongoDBCharts) {
        return Object.keys(this.user[this.namespace].mongoDBCharts).indexOf(this.$route.params.sid) > -1
      }
      return false
    },
    chartsList () {
      if (this.authorized) {
        return this.user[this.namespace].mongoDBCharts[this.$route.params.sid]
      }

    }
  },

  methods: {
    goToAdmin () {
      this.$router.push('/admin')
    },
    logIn () {
      localStorage.setItem('redirect_to_url', this.$route.fullPath)
      this.$auth.login()
    },
  },

  mounted () {
    const namespace = process.env.VUE_APP_NAMESPACE
    /*
     * If user is not logged in, redirect
     */
    setTimeout(() => {
      if (!this.loggedIn) {
        localStorage.setItem('redirect_to_url', this.$route.fullPath)
        this.$router.push('/login')
      }
    }, 50)

    this.$store.commit('ADMIN_SET_SID', { surveyId: this.$route.params.sid })

    // Load this survey if non existent
    if (!this.$store.state.admin.sidList[this.$route.params.sid]) {
      this.$store.dispatch('ADMIN_LOAD_SID', { surveyId: this.$route.params.sid})
    }

    setTimeout(() => {
      const sdk = new ChartsEmbedSDK({
        baseUrl: this.chartsList.url
      })
      this.chartsList.charts.forEach((key, index) => {
        const chart = sdk.createChart({ chartId: key.id, showAttribution: false })
        chart.render(document.getElementById(`chart-${key.id}`))
      })      
    }, 1000)
  },

  watch: {
    'loggedIn': function (newVal) {
      //this.fetchSurveys()
    }
  }
}
</script>

<style scoped lang="scss">
.mongodb-charts-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  min-height: 100vh;
  min-width: 100%;
  border-top: 1px solid $gray-light;
  padding-top: 1em;
  justify-content: space-between;
  align-items: flex-start;
}
#charting,
.chart-block {
  width: 100%;
  height: 400px;
  border: 1px solid $gray-light;
  margin-bottom: 1em;
  @include breakpoint($tablet) {
    width: calc((100vw - 4em) / 3);
    height: 500px;
  }
  &.large {
    @include breakpoint($tablet) {
      width: calc((100vw - 4em) / 3 * 2);
    }
  }
  &.xlarge {
    @include breakpoint($tablet) {
      width: calc((100vw - 4em));
    }
  }
  @include breakpoint($fullhd) {
    width: calc((100vw - 5em) / 4);
    height: 500px;
  }
  &.large {
    @include breakpoint($fullhd) {
      width: calc((100vw - 5em) / 4 * 2);
    }
  }
}
.view-section {
  justify-content: flex-start !important;
}
.filters-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-content: flex-start;
}
.filter-wrapper {
  margin-right: 1em;
  max-width: 28%;
  display: flex;
  flex-direction: row;
  select {
    height: 48px;
  }
}
.clear-filters {
  max-width: 26%;
  margin-top: -6px;
  height: 48px;
  &:hover {
    cursor: pointer;
  }
}
.date-selector-wrapper {
  display: flex;
  flex-direction: column;
  flex: 1;
  @include breakpoint($tablet) {
    flex-direction: row;
  }
  > div {
    @include breakpoint($tablet) {
      padding-right: 1em;
    }
  }
}
.secondary-controls {
  padding-right: 2em;
  display: flex;
  flex-direction: row;
}

.participants-number {
  margin-bottom: 1em;
  font-size: 0.8em;
  border-top: 1px solid $gray-light;
  padding-top: 1.5em;
}
.survey-name {
  margin-bottom: 0;
  font-size: 1.5em;
  @include breakpoint($desktop) {
    font-size: 1em;
  }
  @include breakpoint($fullhd) {
    font-size: 1.3em;
  }
}
.responses {
  font-size: 0.9em;
  margin-bottom: 0;
  @include breakpoint($desktop) {
    font-size: 0.7em;
  }
}
.survey-summary {
  min-height: 0;
}
.toolbar {
  margin-bottom: 1em;  
}
.main-toolbar {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
}
.filter-toolbar {

}
.view-switcher {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  max-width: 40vw;

  .icon-wrapper {
    opacity: 0.5;
    transition: opacity 0.2s ease-in-out;
    margin-left: 5px;
    &.active-view {
      opacity: 1;
    }
    &:hover {
      cursor: pointer;
      opacity: 0.79;
    }
    &.icon-reload {
      margin-right: 2px;
      &:hover {
        cursor: pointer;
      }
    }
  }
}

.date-selector {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}

.collecting-data-wrapper {
  position: relative;
  height: 1em;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-end;
  .collecting-dot {
    width: 0.5em;
    height: 0.5em;
    border-radius: 100%;
    background: $color-wrapper-emphasis;
    margin-right: 0.5em;
    margin-top: 0.5em;
    animation: bounce-in 1s infinite;
    opacity: 0;
    &:hover {
      cursor: pointer;
    }
    &.active{
      opacity: 1;
    }
  }
}
.disabled {
  opacity: 0.1;
}
</style>

<style lang="scss">
.el-select .el-input.is-focus .el-input__inner,
.el-select .el-input__inner:focus {
  border-color: $color-wrapper-emphasis !important;
}
.el-select-dropdown__item.selected {
  color: $color-wrapper-emphasis !important;
}
.el-date-editor.el-input.el-input--prefix.el-input--suffix.el-date-editor--datetime {
  input {
    border: none;
    border-bottom: 1px solid $gray-light;
    border-radius: 0;
    font-size: 1.4em !important;
  }
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: auto !important;
}
.el-select-dropdown__item {
  max-width: 90vw;
  margin: auto;
}
</style>
